<template>
  <div>
    <el-autocomplete
      v-model="value[name]"
      :fetch-suggestions="suggest"
      style="margin-bottom: 1em; max-width: 640px; min-width: 500px"
    >
      <div slot="prepend" style="min-width: 140px">
        {{ setting.label || name }}
        <Tooltip :label="setting.label || name" :content="setting.detail" />
      </div>
    </el-autocomplete>
  </div>
</template>

<script>
/**
 * Autocomplete SmartField - Renders an autocomplete text input for string configuration values.
 *
 * @component
 * @description Displays a text input with autocomplete suggestions filtered from a predefined list.
 * As the user types, suggestions are filtered case-insensitively to match the input.
 * Useful for fields with a known set of common values but allowing custom input.
 *
 * @prop {Object} value - Parent object containing the setting value
 * @prop {Object} setting - Field configuration object
 * @prop {string} [setting.label] - Display label for the input (defaults to name)
 * @prop {string} [setting.detail] - Tooltip text explaining the setting
 * @prop {Array<string>} setting.suggestions - Array of suggestion strings for autocomplete
 * @prop {string} [setting.default] - Default value if not set
 * @prop {string} name - Property key in the value object
 *
 * @example
 * <Autocomplete
 *   :value="config"
 *   :setting="{
 *     label: 'Country',
 *     detail: 'Enter country name',
 *     suggestions: ['Singapore', 'Malaysia', 'Indonesia', 'Thailand'],
 *     default: 'Singapore'
 *   }"
 *   name="country"
 * />
 */
import Tooltip from "../Tooltip.vue";
export default {
  components: { Tooltip },
  props: ["value", "setting", "name"],
  methods: {
    suggest(query, cb) {
      let result = _.filter(this.setting.suggestions, (item) => {
        return item.toLowerCase().indexOf(query.toLowerCase()) > -1;
      });

      cb(result);
    },
  },
  mounted() {
    if (this.value[this.name] == null) {
      if (this.setting.default != null) {
        this.$set(this.value, this.name, this.setting.default);
      } else {
        this.$set(this.value, this.name, null);
      }
    }
  },
};
</script>
